import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetUserList = async function(query) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  const result = await queryThaisookViewBigQuery({
    info: 'get userlist by filter',
    query: `
    select 
      U.uid, 
      concat(U.firstname, ' ', U.lastname) name, 
      O.name org,
      U.phoneNumber,
      U.pictureUrl
    from 
      thaisook_view.users U
      left join thaisook_view.organization O on O.orgId = U.orgId
    where 
      role in('challengeAdmin','superAdmin')
      and (U.firstname like '${query}%' or U.lastname like '${query}%' or U.phoneNumber like '${query}%')
    limit 20
    `
  });
  const resultObj = JSON.parse(result.data);
  return resultObj
};
export default bqGetUserList;
